import type { ButtonHTMLAttributes, ComponentProps } from 'react';
import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type {
  AlignSelfProps,
  BackgroundColorProps,
  BorderProps,
  ColorProps,
  FontSizeProps,
  LineHeightProps,
  SpaceProps,
} from 'styled-system';
import {
  alignSelf,
  backgroundColor,
  border,
  color,
  fontSize,
  lineHeight,
  space,
} from 'styled-system';

import { isTouchDevice } from '../../DeviceDetector';
import { textDecoration } from '../../theme/system-utilities';

export type ButtonProps = ButtonHTMLAttributes<unknown>;

type ButtonStyleProps = AlignSelfProps &
  BackgroundColorProps &
  BorderProps &
  ColorProps &
  FontSizeProps &
  LineHeightProps &
  SpaceProps & { textDecoration?: string };

const UnstyledButton = styled.button<ButtonProps & ButtonStyleProps>`
  ${alignSelf};
  ${backgroundColor};
  ${border};
  ${color};
  ${fontSize};
  ${lineHeight};
  ${space};
  ${textDecoration};
  ${() =>
    isTouchDevice() &&
    css`
      outline: none;
    `}
  cursor: pointer;
`;

const Button = (props: ComponentProps<typeof UnstyledButton>) => (
  <UnstyledButton
    backgroundColor="transparent"
    border="none"
    color="sys.neutral.border.strong"
    fontSize={['fs_16', null, null, 'fs_18']}
    lineHeight={['lh_20', null, null, 'lh_22']}
    m="0"
    mb={['sp_20', 'sp_24', null, 'sp_32']}
    p="0"
    textDecoration="underline"
    type="button"
    {...props}
  />
);

const UnderlinedButton = ({ children, ...props }: ButtonProps & ButtonStyleProps) => (
  <Button {...props}>{children}</Button>
);

export default UnderlinedButton;
